import FeatureGate from "@/src/components/feature-gate";
import EventsCreationScreen from "@/src/screens/events/events-form/events-creation-screen";

export default function EventsCreation() {
  return (
    <FeatureGate feature="events">
      <EventsCreationScreen />
    </FeatureGate>
  );
}
